<div class="card container">
  <p-confirmDialog />
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
    <div class="col-auto align-self-start">
      <p-button
        label="Nuevo"
        severity="primary"
        icon="pi pi-plus"
        size="small"
        routerLink="create"
      />
    </div>
  </div>
  <div style="padding-top: 50px">
    <p-table
      #dt1
      [value]="ltsPublicities"
      [tableStyle]="{
        'min-width': '50rem',
        'margin-bottom': '50px',
      }"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
    >
      <ng-template pTemplate="caption">
        <div class="d-flex">
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Inicio
            </label>
            <p-calendar
              [(ngModel)]="dateStart"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              dateFormat="dd-mm-yy"
              (onSelect)="getListPublicities()"
            />
          </div>
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Fin
            </label>
            <p-calendar
              [(ngModel)]="dateEnd"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              (onSelect)="getListPublicities()"
              dateFormat="dd-mm-yy"
              class="m-3"
            />
          </div>
          <div class="col-4 align-items-left justify-content-center">
            <label for="buttondisplay" class="font-bold block px-2">
              Ciudades
            </label>
            <br />
            <p-dropdown
              [options]="ltsStates"
              [(ngModel)]="selectedState"
              optionLabel="pd_name"
              optionValue="pd_code"
              placeholder="Selecciona un estado"
              class="m-3"
              (onChange)="getListPublicities()"
            />
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th id="title">Titulo</th>
          <th id="description">Descripcion</th>
          <th id="site">Sitio web</th>
          <th id="startDate">Fecha de Inicio</th>
          <th id="endDate">Fecha de Fin</th>
          <th id="city">Ciudad</th>
          <th id="type">Tipo</th>
          <th id="status">Estado</th>
          <th id="action">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-publicity>
        <tr>
          <td>{{ publicity.pub_tilte }}</td>
          <td class="description-column">
            {{ publicity.pub_description }}
          </td>
          <td class="url-columnn">
            {{ publicity.pub_url_site }}
          </td>

          <td>
            <span class="no-break">{{
              publicity.pub_date_start | date: "dd-MM-yyyy"
            }}</span>
          </td>
          <td>
            <span class="no-break">{{
              publicity.pub_date_end | date: "dd-MM-yyyy"
            }}</span>
          </td>
          <td>
            {{ publicity.pd_name ?? "Sin Informacion" }}
          </td>

          <td>
            {{ publicity.typ_name ?? "Sin información" }}
          </td>
          <td>
            <p-inputSwitch
              [(ngModel)]="publicity.pub_active"
              (onChange)="cambiarEstado(publicity)"
            />
          </td>
          <td>
            <div class="d-flex">
              <p-button
                icon="pi pi-file-edit"
                [rounded]="true"
                severity="info"
                pTooltip="Editar"
                (onClick)="openDialog(publicity)"
              />
              <p-divider layout="vertical" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog
  header="{{ tituloDialog }}"
  [resizable]="false"
  [modal]="true"
  [maximizable]="false"
  appendTo="body"
  [(visible)]="dialogEdit"
  [breakpoints]="{ '1199px': '75vw', '575px': '100vw' }"
  [style]="{ width: '45rem', maxHeight: '100vh' }"
  [contentStyle]="{ 'max-height': '300vh', overflow: 'auto' }"
>
  <div class="d-flex justify-content-center">
    <div class="container offset-md-1">
      <div class="row gap-2">
        <div class="row rowPad align-items-left">
          <div class="col-12 col-sm-3">
            <label for="float-input">Titulo*:</label>
          </div>
          <div class="col-12 col-sm-8">
            <label for="float-input">{{ selectedPublicity?.pub_tilte }}</label>
          </div>
        </div>

        <div class="row rowPad align-items-left">
          <div class="col-12 col-sm-3">
            <label for="float-input">Fecha de inicio*:</label>
          </div>
          @if (selectedPublicity) {
            <div class="col-12 col-sm-8">
              <p-calendar
                [(ngModel)]="dateStartEdit"
                [showIcon]="true"
                [showOnFocus]="false"
                dateFormat="dd-mm-yy"
                inputId="dateStart"
                appendTo="body"
              />
            </div>
          }
        </div>

        <div class="row rowPad align-items-left">
          <div class="col-12 col-sm-3">
            <label for="float-input">Fecha de Fin*:</label>
          </div>
          @if (selectedPublicity) {
            <div class="col-12 col-sm-8">
              <p-calendar
                [(ngModel)]="dateEndEdit"
                [showIcon]="true"
                [showOnFocus]="false"
                dateFormat="dd-mm-yy"
                inputId="dateEnd"
                appendTo="body"
              />
            </div>
          }
        </div>

        <div class="d-flex justify-content-end p-2">
            <p-button
              class="p-1"
              label="Cancel"
              severity="primary"
              (onClick)="cancelDialog()"
            />
            <p-button
              class="p-1"
              label="Save"
              (onClick)="updatePublicity()"
            />
          </div>
      </div>
    </div>
  </div>
</p-dialog>
